import { object, string, number } from 'yup';

export default object().shape({
    CompanyName:
        string()
            .required('REQUIRED'),
    CompanyContact:
        string()
            .required('REQUIRED'),
    CompanyPhone:
        string()
            .matches(/^\d{6,15}$/, 'INVALID_PHONE')
            .required('REQUIRED'),
    CompanyEmail:
        string()
            .email('INVALID_EMAIL')
            .required('REQUIRED'),
    AreaCode:
        number()
            .required('REQUIRED'),
    CompanyCountry:
        string()
            .required('REQUIRED'),
    CompanyState:
        string()
            .required('REQUIRED'),
    CompanyCity:
        string()
            .required('REQUIRED'),
    DefaultLanguage:
        string()
            .required('REQUIRED'),
    TimeZone:
        number()
            .required('REQUIRED')
});
